import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableHeadsService } from 'src/app/Core/tableheads.service';
import { PageHeaderComponent } from 'src/app/Core/pageheader.component';
import { AppComponent } from 'src/app/app.component';
import { DesignationApiService } from 'src/app/API/designationapi.service';
import { CommonApiService } from 'src/app/API/commonapi.service.';
import { Injectable } from '@angular/core';
import { DocumentCategoryService } from 'src/app/API/documentcategory.service';

// @Injectable({ providedIn: 'root' })
// export class DocumentCategoryService {
//   private categories: string[] = [
//     'Dialysis Machines',
//     'RO Systems',
//     'Home Program',
//     'Misc. Equipment',
//     'Policies and Procedures'
//   ];
//   getCategories() { return this.categories; }
//   addCategory(name: string) { this.categories.push(name); }
// }


@Component({
  selector: 'DocumentCategoryDetail',
  templateUrl: './DocumentCategoryDetail.component.html',

})
export class DocumentCategoryDetailComponent {
  ListURL = 'Admin/DocumentCategorySearch';
  ShowSearch = false;
  searchText = 'Search Records';
  selectedDivision ='';
  blnDirtySearch = false;
  DialysisUnits = [];
  loading = true;
  today = new Date();
  blnshowSave = true;
  blnshowDelete = false;
  title = "Document Category Detail";
  DivisionList = [];
  documentCategoryName: string = '';

  constructor(
    private designationAPI: DesignationApiService , private router: Router, 
    private commonapi : CommonApiService,
    private dataGridService: TableHeadsService,
    private documentCategoryService: DocumentCategoryService,
    private route: ActivatedRoute  ){
    this.page.pageNumber = 0;
    this.page.size = 25;
  }

  onSearchShowChange(value) {
    this.ShowSearch = value;
  }

  @ViewChild(PageHeaderComponent, { static: true }) pageheader: PageHeaderComponent;
  tableHeaders;
  page = new Page();
  rows ;
  AddUrl = '/Admin/UserDesignationDetail';
  currentPageNumber = 1;
  sortExpression = 'designationName';
  sortDirection = 'ASC';
  pageSize = 25;
  defaultSort;
  documentCategoryId;

  ngOnInit() {
      AppComponent.ShowLoader();
      const test = this.route.queryParams.subscribe(params => {
      this.documentCategoryId =params['id'] || '0';
      if(this.documentCategoryId != '0')
      {
        this.setModel();
      }
      AppComponent.HideLoader();
     });
  }

  setModel() {
    AppComponent.ShowLoader();
    const DocumentCategoryCreate = { Id: this.documentCategoryId };

    this.documentCategoryService.GetDocumentCategoryById(DocumentCategoryCreate).subscribe(
      success => {
        console.log(success);
        this.documentCategoryName = success.documentCategoryName;
        AppComponent.HideLoader();
      },
      error => {
        AppComponent.addAlert(error.message, 'error');
        AppComponent.HideLoader();
      }
    );
  }

  executeDesignationSearchClear() {
    this.selectedDivision = '';   
  }

  CheckDirtySearch() {
    this.blnDirtySearch = false;

    if (
      this.selectedDivision      
    ) {
      this.blnDirtySearch = true;
    }
    return this.blnDirtySearch;
  }
  
   
  changeSorting(column) {
    if (column === '#') {
      return;
    }
    this.dataGridService.changeSorting(column, this.defaultSort, this.tableHeaders);
    this.defaultSort = this.dataGridService.getSort();
    this.sortDirection = this.dataGridService.getSortDirection();
    this.sortExpression = this.dataGridService.getSortExpression();
    this.currentPageNumber = 1;
    this.page.pageNumber = 1;
  }

  setSortIndicator = function (column) {
      return this.dataGridService.setSortIndicator(column, this.defaultSort);
  };
 
  executeDesignationCreateUpdate = function (Source) {
   
  };

  
  saveCategory() {

    console.log('Inside save category >>>>>>>>>>>>>>>>');
    console.log('this.documentCategoryId >>>>>>>>>>>>>>'+this.documentCategoryId);

    if (!this.documentCategoryName || !this.documentCategoryName.trim()) {
      AppComponent.addAlert('Please enter a document category name.', 'error');
      return;
    }
    const documentCategoryName = { str: this.documentCategoryName.trim() };

    if(this.documentCategoryId == '0')
    {
      this.documentCategoryService.CreateDocumentCategory(documentCategoryName).subscribe(
        success => {
            console.log(success);
          AppComponent.loading = false;
          AppComponent.addAlert('Data Saved successfully!', 'success');
          this.router.navigate(['/Admin/DocumentCategorySearch']);
        },
        error => {
          AppComponent.addAlert(error.message, 'error');
          AppComponent.HideLoader();
        }
      );
    }
    else 
    {
        const DocumentCategoryCreate = this.prepareCreateViewModel();
        this.documentCategoryService.UpdateDocumentCategory(DocumentCategoryCreate).subscribe(
        success => {
            console.log(success);
          AppComponent.loading = false;
          AppComponent.addAlert('Data Saved successfully!', 'success');
          this.router.navigate(['/Admin/DocumentCategorySearch']);
        },
        error => {
          AppComponent.addAlert(error.message, 'error');
          AppComponent.HideLoader();
        }
      );
    }
  }

  prepareCreateViewModel() {
    const DocumentCategoryCreate = <any>{};
    DocumentCategoryCreate.documentCategoryId =  this.documentCategoryId;
    DocumentCategoryCreate.documentCategoryName = this.documentCategoryName;
    return DocumentCategoryCreate;
  }
 
  setPage() {
    this.currentPageNumber = this.page.pageNumber;
  }

   _onRowClick(row) {
    this.router.navigate([this.AddUrl], { queryParams: { id: row } });
  }
}

export class Page {
  // The number of elements in the page
  size: number = 0;
  // The total number of elements
  totalElements: number = 0;
  // The total number of pages
  totalPages: number = 0;
  // The current page number
  pageNumber: number = 0;
}
